export class AmountControl {
	constructor(node, config) {
		this.node = node;
		this.amount = config.value ? parseInt(config.value) : 0;
		this.amountNode = node.querySelector('.c-tk-amount-counter__value');
		this.plusButton = node.querySelector('[data-type="plus"]');
		this.minusButton = node.querySelector('[data-type="minus"]');

		this.min = config.min ? parseInt(config.min) : 0;
		this.max = config.max ? parseInt(config.max) : 9999;

		this.plusButton.addEventListener('click', this.handleButtonClick.bind(this, 'plus'));
		this.minusButton.addEventListener('click', this.handleButtonClick.bind(this, 'minus'));

		this.init();
	}

	init() {
	}

	decreaseAmount() {
		const newValue = this.amount - 1;

		this.amount = newValue < this.min ? this.amount : newValue;
		this.amountNode.textContent = this.amount;
	}

	getIncreasedAmount() {
		let newValue = this.amount + 1;

		newValue = newValue > this.max ? this.amount : newValue;
		this.amountNode.textContent = this.amount;

		return newValue;
	}

	getDecreaseAmount() {
		let newValue = this.amount - 1;

		newValue = newValue < this.min ? this.amount : newValue;
		this.amountNode.textContent = newValue;

		return newValue;
	}

	setAmount(number) {
		this.amount = parseInt(number);
		this.amountNode.textContent = this.amount;
	}

	handleButtonClick(clickType) {
		const self = this;
		const oldAmount = self.amount;

		let type = clickType === 'plus' ? clickType : 'minus';
		const newValue = clickType === 'plus' ? self.getIncreasedAmount() : self.getDecreaseAmount();

		if (oldAmount === newValue) {
			return;
		}

		const event = new CustomEvent('changeAmount', {
			detail: { amount: newValue, oldAmount: oldAmount }
		})

		self.node.dispatchEvent(event);
	}

	handlePlusClick() {
		const self = this;

		const oldAmount = self.amount;

		if (oldAmount === self.getIncreasedAmount()) {
			return;
		}

		const event = new CustomEvent('increaseAmount', {
			detail: { amount: self.getIncreasedAmount(), oldAmount: oldAmount }
		})

		self.node.dispatchEvent(event);
	}

	handleMinusClick() {
		const self = this;

		const oldAmount = self.amount;
		self.decreaseAmount();


		const event = new CustomEvent('decreaseAmount', {
			detail: { amount: self.amount, oldAmount: oldAmount }
		})

		self.minusButton.dispatchEvent(event);

		const changeEvent = new CustomEvent('change', {
			detail: { amount: self.amount },
		})

		self.plusButton.dispatchEvent(changeEvent);
	}

	onChange(callback) {
		this.plusButton.addEventListener('change', callback);
		this.minusButton.addEventListener('change', callback);
	}

	onIncreaseAmount(callback) {
		this.plusButton.addEventListener('increaseAmount', callback);
	}

	onDecreaseAmount(callback) {
		this.minusButton.addEventListener('decreaseAmount', callback);
	}
}
